import { render, staticRenderFns } from "./dialogPopup.vue?vue&type=template&id=68ff391a&"
import script from "./dialogPopup.vue?vue&type=script&lang=js&"
export * from "./dialogPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports